/* eslint-disable eag/match-named-export */
import {z} from '@hono/zod-openapi';

import {conversationParams} from '../../modules/conversation/conversationParams';
import {conversationEvent} from '../../modules/event/conversationEvent';

export const sendWhatsappMessageParams = conversationParams;

export type SendWhatsappMessageParams = z.infer<typeof sendWhatsappMessageParams>;

export const sendWhatsappMessageBody = z.object({
  content: z.string().min(1).max(2000).openapi({
    description: 'WhatsApp message content (1-2000 characters)',
    example: 'Hello, this is a WhatsApp message.',
  }),
  userId: z.string().uuid().openapi({
    description: 'ID of the user sending the WhatsApp message',
    example: '123e4567-e89b-12d3-a456-426614174000',
  }),
  whatsAppMessageId: z.string().min(1).openapi({
    description: 'WhatsApp message ID',
    example:
      'wamid.ABGBIRNGNkVGNkUwMjkwMjQ0NjI5NjI1MDU2MjM0MDcwNjI5NjI0NDYyOTIwMjQ0NjI5NjI0NDYyNDQ2Mjk2MjQ0NjI5MjA0NjI5NjI0NDYyNDQ2Mjk2MjQ0NjI5',
  }),
});

export type SendWhatsappMessageBody = z.infer<typeof sendWhatsappMessageBody>;

export const sendWhatsappMessageResponse = conversationEvent;

export type SendWhatsappMessageResponse = z.infer<typeof sendWhatsappMessageResponse>;
